import { ChangeDetectorRef, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { SearchFieldComponent } from '../../components/search-field/search-field.component';
import _ from 'lodash';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { Router, RouterModule } from '@angular/router';
import { Menubar } from 'primeng/menubar';
import { MenuItem } from 'primeng/api';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../services/auth.service';
import { environment } from '../../../environments/environment';
import { TournamentService } from '../../services/tournament.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LogService } from '../../services/log.service';
import { AuxiliarService } from '../../services/auxiliar.service';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-tournaments',
  imports: [
    ButtonModule,
    CommonModule,
    Menubar,
    RouterModule,
    SearchFieldComponent,
    TooltipModule,
    TranslatePipe,
  ],
  templateUrl: './tournaments.component.html',
  styleUrl: './tournaments.component.scss',
})
export class TournamentsComponent implements OnInit {
  private readonly destroy$ = inject(DestroyRef);
  public isDev: boolean = false;
  public items: MenuItem[] | undefined;
  public loadingTournamentDev: boolean = false;

  constructor(
    public authService: AuthService,
    public auxiliarService: AuxiliarService,
    public cdr: ChangeDetectorRef,
    public logService: LogService,
    private router: Router,
    private tournamentService: TournamentService,
    private translate: TranslateService,
  ){}

  ngOnInit(): void {
    this.isDev = _.includes(environment.api_server, 'talentosoftware');
    this.buildMenu();
    this.translate.onLangChange
      .subscribe(() => {
        this.buildMenu();
      });
  }

  private buildMenu(): void {
    this.items = [
      {
        id: 'active',
        label: this.translate.instant('menu.tournaments-active'),
        command: () => {
          this.router.navigate(['admin', 'tournaments', 'active']);
        },
        isActive: () => _.includes(this.router.url, '/active'),
      },
      {
        id: 'finished',
        label: this.translate.instant('menu.tournaments-finished'),
        command: () => {
          this.router.navigate(['admin', 'tournaments', 'finished']);
        },
        isActive: () => _.includes(this.router.url, '/finished'),
      },
    ];

    const activeItem = this.router.url.split('/').pop();
    this.router.navigate(['admin', 'tournaments', 
      _.includes(['finished'], activeItem) ? activeItem : 'active']);
  }

  public addTournament(): void {
    this.router.navigate(['admin', 'tournaments', 'new']);
  }

  // function to add new tournament with random teams, groups && rounds
  public addTournamentDev(): void {
    this.loadingTournamentDev = true;
    this.tournamentService.createTournamentDev()
      .pipe(
        takeUntilDestroyed(this.destroy$),
        finalize(() => this.loadingTournamentDev = false)
      ).subscribe({
        next: (res) => {
          this.logService.info('[Tournament] - createTournamentDev', res, this.translate.instant('success.tournament-create'));
          setTimeout(() => {
            this.router.navigate(['admin', 'tournaments']);
          });
        },
        error: (err) => {
          // TODO
          // this.logService.error('[Tournament] - createTournament', err, this.translate.instant('error.tournament-create'));
          this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this.router.navigate(['admin', 'tournaments']);
          });
        }
      });
  }
}
